<div class="library-selector-container">
  <h3>Select a Library</h3>

  <div *ngIf="isLoading" class="loading-spinner">
    <img src="assets\ajax-loader.gif" alt="Loading...">
  </div>

  <div *ngIf="!isLoading">
    <div>
      <input matInput (input)="onSearchTermChange($event.target)" placeholder="Enter library name">
      <ul *ngIf="!errorMessage">
        <li *ngFor="let libraryName of filteredLibraryNames$ | async" 
            (click)="selectLibrary(libraryName)" 
            [attr.title]="getAliasName(libraryName)"
            [class.selected]="libraryName === selectedLibraryName">
          {{ libraryName }}
        </li>
      </ul>
    </div>   
    <div *ngIf="errorMessage" class="error-message">{{ errorMessage }}</div> 
  </div>
</div>